/** Gemeinsame IFrame-Optionen: keine Close-Page/Werbung, Hangup an uns durchreichen. */
export function jitsiConfigOverwrite(extra = {}) {
  return {
    disableDeepLinking: true,
    enableClosePage: false,
    disableInviteFunctions: true,
    buttonsWithNotifyClick: [{ key: 'hangup', preventExecution: true }],
    ...extra,
  };
}

export function jitsiInterfaceConfigOverwrite() {
  return {
    SHOW_JITSI_WATERMARK: false,
    SHOW_WATERMARK_FOR_GUESTS: false,
    SHOW_BRAND_WATERMARK: false,
    SHOW_POWERED_BY: false,
    MOBILE_APP_PROMO: false,
  };
}

/** IFrame sofort entfernen, sobald der Nutzer auflegt — bevor meet.jit.si die 8x8-Werbung zeigt. */
export function attachJitsiLeaveHandler(api, onLeave) {
  let left = false;
  const leave = () => {
    if (left) return;
    left = true;
    try { api.dispose(); } catch { /* iframe schon weg */ }
    onLeave();
  };
  api.addEventListener('readyToClose', leave);
  api.addEventListener('videoConferenceLeft', leave);
  api.addEventListener('toolbarButtonClicked', (e) => {
    const key = e?.key || e?.buttonName;
    if (key === 'hangup') leave();
  });
  return leave;
}

/** Lädt die Jitsi IFrame-API einmalig von der angegebenen Domain. */
export function loadJitsiApi(domain) {
  if (window.JitsiMeetExternalAPI) {
    return Promise.resolve(window.JitsiMeetExternalAPI);
  }
  return new Promise((resolve, reject) => {
    const existing = document.querySelector(`script[data-jitsi-api="${domain}"]`);
    if (existing) {
      existing.addEventListener('load', () => resolve(window.JitsiMeetExternalAPI));
      existing.addEventListener('error', () => reject(new Error('jitsi-script')));
      return;
    }
    const script = document.createElement('script');
    script.src = `https://${domain}/external_api.js`;
    script.async = true;
    script.dataset.jitsiApi = domain;
    script.onload = () => resolve(window.JitsiMeetExternalAPI);
    script.onerror = () => reject(new Error('jitsi-script'));
    document.body.appendChild(script);
  });
}
